import * as jsxRuntime from "/opt/actions-runner/_work/cbh-admin-frontend/cbh-admin-frontend/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment